<template>
    <div class="custom-vertical-steps">
        <div v-for="(step, index) in steps" :key="index" class="step-item" :class="{
            'active': index === activeIndex,
            'completed': index < activeIndex,
            'last-item': index === steps.length - 1
        }">
            <!-- 步骤连接线（虚线） -->
            <div class="step-connector" v-if="index !== steps.length - 1"></div>

            <!-- 步骤图标 -->
            <div class="step-icon">
                <!-- <span v-if="index < activeIndex">✓</span>
        <span v-else>{{ index + 1 }}</span> -->
            </div>

            <!-- 步骤内容 -->
            <div class="step-content">
                <div class="step-title">{{ step.title }}</div>
                <div class="step-description" >{{ step?.description }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        steps: {
            type: Array,
            required: true,
            validator: value => value.every(item => item.title)
        },
        activeIndex: {
            type: Number,
            default: 0,
            validator: value => value >= 0
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-vertical-steps {
    font-family: MicrosoftYaHei;
    display: flex;
    flex-direction: column;
    flex: 1;
    .step-item {
        position: relative;
        display: flex;
        flex: 1;
        // padding-bottom: 10px;

        // &:not(.last-item) {
        //   min-height: 20px;
        // }

        // &.completed {
        //   .step-icon {
        //     background-color: #4CAF50;
        //     color: white;
        //   }

        //   .step-title {
        //     color: #4CAF50;
        //     font-weight: bold;
        //   }
        // }

        &.active {
            .step-icon {
                background-color: #FFA853;
                color: white;
                border-color: #FFA853;
            }

            .step-title {
                color: #333333;
                // font-weight: bold;
            }
        }
    }

    .step-connector {
        position: absolute;
        left: 5px;
        top: 11px;
        bottom: 0;
        width: 2px;
        border-left: 1px dashed #FFA853;
    }

    .step-icon {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #FFA853;
        color: white;
        border-color: #FFA853;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        flex-shrink: 0;
        // border: 2px solid #E0E0E0;
        font-size: 14px;
        font-weight: bold;
        z-index: 1;
    }

      .step-content {
        margin-top: -3px;
      }

    .step-title {
        font-size: 16px;
        color: #333333;
        margin-bottom: 4px;
        line-height: 1;
    }

    .step-description {
        font-size: 14px;
        color: #757575;
        height: 5px;
    }
}
</style>